// Owner types for objects uploaded straight to S3 through the presign flow
// (createSignedUploadUrl -> PUT -> makeFileAccessibleToPublic). They have no
// owning entity in the domain, so they carry a synthetic owner type instead of
// an OwnerTypes value. Values double as File.ownerType, which is the grouping
// key of the workspace storage breakdown — keep them stable.
export const PublishedAssetTypes = {
    RICH_TEXT_IMAGE: "rich-text-image",
    RICH_TEXT_DOCUMENT: "rich-text-document",
    DASHBOARD_IMAGE: "dashboard-image",
    WORKSPACE_LOGO: "workspace-logo",
    PROFILE_PICTURE: "profile-picture",
};
const PUBLISHED_ASSET_TYPE_MAP = Object.fromEntries(Object.values(PublishedAssetTypes).map((assetType) => [assetType, assetType]));
export const publishedAssetTypeFromString = (str) => PUBLISHED_ASSET_TYPE_MAP[str];
// Personal assets belong to a user, not a workspace, so they are never
// attributed to one even when the uploader is acting inside a workspace.
export const isPersonalPublishedAssetType = (assetType) => assetType === PublishedAssetTypes.PROFILE_PICTURE;
